import validate from "validate.js";
import { STATE } from '../storeConstants';
import { roundDollarsToCents } from "../util/bankersRound";

const validations = {
  [STATE.INTEREST_RATE]: {
    numericality: { message: '^Must be between 0 and 100' }
  },
  [STATE.HOA_FEES]: {
    numericality: {
      greaterThanOrEqualTo: 0,
      message: '^Must be a number > 0'
    }
  },
  [STATE.PROPERTY_TAX]: {
    numericality: {
      greaterThanOrEqualTo: 0,
      message: '^Must be a number > 0'
    }
  },
  [STATE.INSURANCE_COST]: {
    numericality: {
      greaterThanOrEqualTo: 0,
      message: '^Must be a number > 0'
    }
  },

  [STATE.PRINCIPLE]: {
    transform: function (val) {

      return typeof val === "object"
        ? roundDollarsToCents(val.target.value.replace(/[^0-9.]/g, ""), 10)
        : val;
    },
    numericality: {
      greaterThanOrEqualTo: 1000000,
      lessThanOrEqualTo: 100000100,
      message: '^Must be between $10,000 and $1,000,000'
    }
  },
  [STATE.EXTRA_MONTHLY_PAYMENT_AMOUNT]: {
    numericality: {
      greaterThanOrEqualTo: 0,
      lessThanOrEqualTo: 1000,
      message: '^Range: $0 and $1000'
    }
  },
  [STATE.ANNUAL_PAYMENT_AMOUNT]: {
    numericality: {
      greaterThanOrEqualTo: 0,
      lessThanOrEqualTo: 10000,
      message: '^Range:  $0 and $10,000'
    }
  },
  [STATE.ONE_TIME_PAYMENT_AMOUNT]: {
    transform: function (val) {
      return roundDollarsToCents(val.replace(/[^0-9.-]/g, ""));
    },
    numericality: {
      greaterThanOrEqualTo: 0,
      lessThanOrEqualTo: 10000000,
      message: '^Range: $0 and $100,000'
    }
  },
  [STATE.DOWNPAYMENT]: {
    transform: function (val) {
      return roundDollarsToCents(val.replace(/[^0-9.]/g, ""));
    },
    numericality: {
      greaterThanOrEqualTo: 0,
      lessThanOrEqualTo: 100000000,
      message: '^Must be between $0.00 and $1,000,000'
    }
  },
  DOWNPAYMENT_PERCENTAGE: {
    numericality: {
      greaterThanOrEqualTo: 0,
      lessThanOrEqualTo: 99.99,
      message: '^invalid'
    }
  },
  [STATE.TERM]: {
    transform: function (val) {
      return parseInt(val, 10) * 12;

    },
    numericality: {
      greaterThan: 0,
      lessThanOrEqualTo: 600,
      message: '^Must be between 1 and 50 years'
    }
  },

}


export function checkValidation({ state, change, target, value }) {
  if (!validations[target]) return true;
  let val = value;
  if (validations[target].transform) {
    val = validations[target].transform(val, state);
  }
  let validationErrors = invalid({ target, val });

  let errors = { ...state.ERRORS };
  delete errors[target];
  if (validationErrors) {
    errors = {
      ...errors,
      [target]: validationErrors[target]
    };
  }
  change({
    target: "ERRORS",
    value: { ...errors }
  });
  if (!validationErrors) return true;
  return false;

}

export function invalid({ target, val }) {
  let rules = { ...validations[target] }
  delete rules.transform; //remove the transform function before passing to validate.js
  const test = validate(
    { [target]: val },
    {
      [target]: {
        ...rules
      }
    });
  return typeof test === 'undefined' ? false : test;
}

